import { ItemSms, Mill } from "./itemParametersValues.model";
import { RawMaterialGrade } from "./rawMaterialGrades.model";

export class ItemsFromXlsx {
    items?: ItemFromXlsx[];
}

export class ItemFromXlsx {
    itemNo?: string;
    customerItemNo?: string;
    alloySurchargeField?: {
        value?: boolean;
        message?: string;
        isValid?: boolean;
    };
    applicableNormsField?: {
        value?: string;
        message?: string;
        isValid?: boolean;
    };
    normGradesField?: {
        value?: [
            {
                normGradeId?: number;
                normGradeCode?: string;
            }
        ];
        message?: string;
        isValid?: boolean;
    };
    gradeCustomerAnalysisLimitationField?: {
        value?: [
            {
                isCustom?: boolean;
                limitation?: string;
            }
        ]
        message?: string;
        isValid?: boolean;
    };
    gradeCustomerOtherLimitationField?: {
        value?: [
            {
                isCustom?: boolean;
                limitation?: string;
            }
        ]
        message?: string;
        isValid?: boolean;
    };
    marketingGradeField?: {
        value?:
        {
            marketingGradeId: number;
            marketingGradeCode: string;
            isDefault: boolean;
        },
        message: string;
        isValid: boolean;
    };
    rawMaterialGradeField?: {
        value: RawMaterialGrade,
        message: string;
        isValid: boolean;
    };
    unitSystemField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    quantityField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    quantityUomField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    odField?: {
        value: Number;
        message: string;
        isValid: boolean;
    };
    odUomField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    wtField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    wtUomField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    idField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    idUomField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    npsScheduleField?: {
        value: {
            npsScheduleId: number;
            npsDescription: string;
            nps: string;
            schedule: string;
            odMetric: number;
            wtMetric: number;
            odImperial: number;
            wtImperial: number;
        } | undefined,
        message: string;
        isValid: boolean;
    };
    typeOfToleranceField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    tubeExecutionField?: {
        value?: {
            description?: string;
            isCustom?: boolean;
            isDefaultForHot?: boolean;
            isDefaultForCold?: boolean;
            name?: string;
            toleranceMinusAw?: number;
            toleranceMinusMw?: number;
            tolerancePlusAw?: number;
            tolerancePlusMw?: number;
            tubeExecutionId?: number;
        }
        message: string;
        isValid: boolean;
    };
    wtToleranceMinusField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    wtTolerancePlusField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    lengthTypeField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    lengthMinField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    lengthMaxField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    smsField?: {
        value: ItemSms,
        message: string;
        isValid: boolean;
    };
    marketingRouteField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    marketFamilyField?: {
        value?: {
            marketFamilyId: number;
            name: string;
            description: string;
            isDefaultForStock: boolean;
            isDefaultForProject: boolean;
        },
        message: string;
        isValid: boolean;
    };
    utField?: {
        value: boolean;
        message: string;
        isValid: boolean;
    };
    hydroTestField?: {
        value: boolean;
        message: string;
        isValid: boolean;
    };
    endsConditionField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    htField?: {
        value: boolean;
        message: string;
        isValid: boolean;
    };
    htAdditionalField?: {
        value: boolean;
        message: string;
        isValid: boolean;
    };
    inspectionType3dot2Field?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    multipleCuttingField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    surfaceTypeField?: {
        value?: {
            surfaceTypeId: number;
            name: string;
            description: string;
        },
        message: string;
        isValid: boolean;
    };
    millField?: {
        value?: Mill,
        message: string;
        isValid: boolean;
    };
    totalWeightField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    totalWeightUomField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    optionDateField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    customerDeliveryDateField?: {
        value: number;
        message: string;
        isValid: boolean;
    };
    materialField?: {
        value?: {
            materialCode: string
        };
        message: string;
        isValid: boolean;
    };
    uBentField?: {
        value?: boolean;
        message: string;
        isValid: boolean;
    };
    testConditionField?: {
        value: string;
        message: string;
        isValid: boolean;
    };
    sqlField?: {
        value?: {
            sqlId: number;
            name: string;
        },
        message: string;
        isValid: boolean;
    };
    offerSchemeField?: {
        value?: string;
        message: string;
        isValid: boolean;
    };
    remarkField?: {
        value?: string;
        message: string;
        isValid: boolean;
    };
}

export class DownloadGridColumn {
    columnName?: string;
    columnLabel?: string;
}